import { InjectionToken } from '@angular/core';

export const SLT_MASTER_ORDER_API_BASE_URL = new InjectionToken<string>('SLT_MASTER_ORDER_API_BASE_URL', {
  providedIn: 'root',
  factory: () => '/slt/api/master/secure/jas/',
});

export const SLT_RATE_REQUEST_API_BASE_URL = new InjectionToken<string>('SLT_RATE_REQUEST_API_BASE_URL', {
  providedIn: 'root',
  factory: () => '/slt/api/rate/request/secure/jas/',
});

export const SLT_SHOP_ORDER_API_BASE_URL  = new InjectionToken<string>('SLT_SHOP_ORDER_API_BASE_URL', {
  providedIn: 'root',
  factory: () => '/slt/api/shop/order/secure/jas/',
});

export const SLT_CARRIER_API_BASE_URL  = new InjectionToken<string>('SLT_CARRIER_API_BASE_URL', {
  providedIn: 'root',
  factory: () => '/slt/api/carrier/portal/secure/jas/',
});

export const LUP_ALINEA_EXTERNAL_URL  = new InjectionToken<string>('LUP_ALINEA_EXTERNAL_URL', {
  providedIn: 'root',
  factory: () => '/lup/alinea-external-interfaces-service/',
});